import { render, staticRenderFns } from "./addWbxm.vue?vue&type=template&id=ff75c09c&"
import script from "./addWbxm.vue?vue&type=script&lang=js&"
export * from "./addWbxm.vue?vue&type=script&lang=js&"
import style0 from "./addWbxm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports